import { Page } from './page';

/**
 * An object used to get sorted page information from the server
 */
export class SortedPage extends Page {
    // The property to sort on
    public sortProperty = '';
    // The sort direction
    public sortDirection = '';
}
